import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import {
  CustomTextField,
  RequiredMark
} from '@components/Styles/CommonStyle';
import React from 'react';


const CompanyAccountCreateTableName = React.memo(({ param, setParam }) => {

  return (
    <React.Fragment>
        <CustomTableRow>
            <CustomHeaderCell>
                <RequiredMark />
                업체명
            </CustomHeaderCell>
            <CustomBodyCell>
                <CustomTextField
                value={param.companyName}
                onChange={(e) => setParam({ ...param, companyName: e.target.value })}
                />
            </CustomBodyCell>
            <CustomHeaderCell>사업자 정보</CustomHeaderCell>
            <CustomBodyCell>
                <CustomTextField
                value={param.companyBusinessNumber}
                onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                    setParam({ ...param, companyBusinessNumber: value });
                    }
                }}
                />
            </CustomBodyCell>
            </CustomTableRow>
    </React.Fragment>
  );
});

export default CompanyAccountCreateTableName;

